import FlagshipIcon from "../../assets/product-list-assets/wifi-flagship.svg";
import type { ProductListGroup } from "../../types";

export const wifiFlagship: ProductListGroup = {
  id: "flagship",
  title: "productListGroup.wifiFlagship.title",
  icon: {
    src: FlagshipIcon,
    width: 16,
    height: 21,
  },
};
